import BarcodeRenderer from 'react-barcode';

const Barcode = ({ code }: { code: string }) => (
  <BarcodeRenderer value={code} displayValue={false} />
);

export default Barcode
